import React from 'react';
import { get } from 'lodash';
import { Modal } from 'antd';
// import { DraggableModal } from 'ant-design-draggable-modal'
import {
  EuiLoadingContent,
  EuiModalBody,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiOverlayMask,
  EuiModal,
} from 'stable-eui';
import { getMessage } from 'utils';
import HeaderSearchTabs from './Tabs';
import './styles.less';

export default (props) => {
  let title = '';

  switch (props.type) {
    case 'CHUYEN_THU':
      const CT = get(props, 'data.searchText', '');
      title = `[${getMessage('layout.search.shipment.title')}] ` + CT;
      break;
    case 'PHIEU_GUI':
      const PG = get(props, 'data.searchText', '');
      title = `[${getMessage('pages.warehouse.common.tracking_code')}] ` + PG;
      break;
    case 'BANG_KE':
      const BK = get(props, 'data.searchText', '');
      title = '[Bảng kê] ' + BK;
      break;
    case 'TUI_THU':
      title = getMessage('layout.search.packinglist.title');
      const t = get(props, 'data.searchText', '');
      title = `[${getMessage('layout.search.packinglist.title')}] ` + t;
      break;
    case 'BUU_CUC':
      const BC = get(props, 'data.searchText', '');
      title = '[Bưu cục] ' + BC;
      break;
    default:
      break;
  }

  return (
    <EuiOverlayMask hidden={props.visible ? 'true' : 'false'}>
      <Modal
        visible={props.visible}
        footer={null}
        closable={false}
        destroyOnClose={false}
        onCancel={() => props.closeModal()}
        width={1000}
        zIndex={999999999}
      >
        <EuiModal style={{ maxWidth: 1000 }} onClose={() => props.closeModal()}>
          <EuiModalHeader>
            <EuiModalHeaderTitle>{title}</EuiModalHeaderTitle>
          </EuiModalHeader>
          {props.isLoading ? (
            <EuiLoadingContent lines={10} />
          ) : (
            <EuiModalBody>
              <HeaderSearchTabs type={props.type} data={props.data} />
            </EuiModalBody>
          )}
        </EuiModal>
      </Modal>
    </EuiOverlayMask>
  );
};
